import React from 'react';
import Iframe from 'react-iframe';


class Live extends React.Component {
    render() {
        return (
            <>
                <img className="background" src='https://free4kwallpapers.com/uploads/originals/2016/06/22/up-close-on-earth-4k-wallpaper.jpg'/>
            <div className="iframesContainer">
                    <Iframe src="https://ustream.tv/embed/17074538" />
            </div>
            </>
        )
    }
    }
    
export default Live;